<template>
  <Head title="Terms and Conditions" />

  <div class="flex flex-col min-h-screen bg-gray-100">
    <div class="flex flex-row justify-between w-100 z-10 relative">
      <div
        id="logo"
        class="text-left p-5"
      >
        <img
          :src="asset('images/logo.png')"
          class="w-44"
        />
      </div>
      <div class="fixed top-0 right-0 px-6 py-4 sm:block">
        <Link
          v-if="$page.props.auth.user"
          href="/dashboard"
          class="block transition-all text-blue-600 px-6 py-3 font-bold tracking-wide bg-gray-400 uppercase rounded hover:bg-blue-600 hover:text-gray-400"
        >
          Dashboard
        </Link>

        <template v-else>
          <a
            :href="route('login')"
            class="block transition-all text-blue-600 px-6 py-3 font-bold tracking-wide bg-gray-400 uppercase rounded hover:bg-blue-600 hover:text-gray-400"
          >
            Login
          </a>
          <!-- <Link v-if="canRegister" :href="route('register')" class="ml-4 text-sm text-gray-700 underline">
                        Register
                    </Link> -->
        </template>
      </div>
    </div>

    <div class="w-100 flex grow">
      <div class="mx-auto max-w-full md:max-w-6xl pt-10 pb-10">
        <div class="w-full bg-gray-100 bg-opacity-95 px-5">
          <!--                    <h1 class="tracking-widest uppercase mt-7" style="font-size: 2.5rem; line-height: 3rem">Connecting <br><b>Cannabis.</b></h1>-->
          <!--                    <p class="tracking-wide font-normal my-5 text-lg">Salve is a single-source of confidence for the business across an unlimited number of software providers. Giving the power and control back to the business owner to make decisions faster without systematic concerns</p>
-->
          <!--                    <a target="_blank" class="inline-block transition-all bg-blue-600 hover:text-blue-600 px-6 py-3 font-bold tracking-wide uppercase rounded hover:bg-gray-300 text-gray-400" href="https://getsalve.co">Learn More</a>-->

          <p class="tracking-wide font-normal text-lg"><strong>User Licensing Agreement</strong></p>

          <p class="tracking-wide font-normal text-lg mt-6">
            This User License Agreement (“ULA”) is entered into and agreed upon by you, the Company (“Company” or “You”)
            and SALVE, LLC (“Salve”) for the Salve cloud-based software technology to manage a fully customized,
            integrated commerce platform enabling multi-location operators to sell, report, manage inventory, automate
            and scale their operation.
          </p>

          <p class="tracking-wide font-normal text-lg mt-6">
            This Agreement is effective as of the date Company executed the Software as a Service Contract (the
            “Effective Date”), and this agreement is equivalent to a written agreement signed by Company and each
            employee of the Company.
          </p>

          <p class="tracking-wide font-normal text-lg mt-6">
            IT IS ILLEGAL AND STRICTLY PROHIBITED TO DISTRIBUTE, PUBLISH, OFFER FOR SALE, LICENSE OR SUBLICENSE, GIVE OR
            DISCLOSE TO ANY OTHER PARTY, THIS CLOUD-BASED SOFTWARE OR THE DOCUMENTS IN HARD COPY, DIGITAL FORM OR ANY
            OTHER MEDIUM WHETHER EXISTING OR NOT YET EXISTING.
          </p>

          <p class="tracking-wide font-normal text-lg mt-6">
            The use of this cloud-based software is governed by the terms and conditions set forth herein and the Salve
            Terms of Service referenced in the link (above). Please read them carefully.
          </p>

          <p class="tracking-wide font-normal text-lg mt-6"><strong>Intellectual Property Rights</strong></p>

          <p class="tracking-wide font-normal text-lg mt-6">
            You acknowledge and agree that the cloud-based software is the confidential and proprietary property of
            Salve. You further acknowledge and agree that the cloud-based Salve software contains specific programs and
            design features that are or may be protected by Salve’s patent, copyright, trademark, service mark, trade
            secret, trade name or other intellectual property rights (collectively, the Intellectual Property Rights”).
          </p>

          <p class="tracking-wide font-normal text-lg mt-6">
            You shall not disclose or make available the Intellectual Property Rights in any manner to any third party.
            This ULA does not convey to You any such Intellectual Property Rights except the limited rights as expressly
            set forth in this ULA.
          </p>

          <p class="tracking-wide font-normal text-lg mt-6">
            You further agree that You shall not disclose to any third party any information concerning the customers,
            trade secrets, methods, processes or procedures or any other confidential, financial or business information
            of any party at any time.
          </p>

          <p class="tracking-wide font-normal text-lg mt-6">
            These obligations shall continue after the termination of this ULA.
          </p>

          <p class="tracking-wide font-normal text-lg mt-6">
            The Salve cloud-based Software contains trade secrets and proprietary know-how that are owned by Salve and
            it is being made available to you in strict confidence. ANY USE OR DISCLOSURE OF THE SOFTWARE, OR OF ITS
            ALGORITHMS, PROTOCOLS OR INTERFACES, OTHER THAN IN STRICT ACCORDANCE WITH THIS ULA, MAY BE LEGALLY
            ACTIONABLE AS A VIOLATION OF SALVE’S TRADE SECRET RIGHTS.
          </p>

          <p class="tracking-wide font-normal text-lg mt-6">Non-Transfer of Rights and Other Restrictions</p>

          <p class="tracking-wide font-normal text-lg mt-6">
            You may not rent, lease, sell, sublicense, assign or transfer your rights in the software. You may not:
          </p>

          <p class="tracking-wide font-normal text-lg mt-6">
            reverse engineer, disassemble, make or attempt to derive the source code of the Salve cloud-based Software,
            or the underlying ideas or algorithms of the Salve cloud-based Software;
          </p>

          <p class="tracking-wide font-normal text-lg mt-6">
            remove or alter any Salve trademark, logo, copyright or other proprietary notices or symbols in the
            cloud-based Software;
          </p>

          <p class="tracking-wide font-normal text-lg mt-6">
            modify or create any derivative works of the Software or documentation, including customization, any
            modifications or enhancements, translation or localization;
          </p>

          <p class="tracking-wide font-normal text-lg mt-6">
            incorporate, integrate or otherwise include the Software or any portion thereof into any software, program
            or product;
          </p>

          <p class="tracking-wide font-normal text-lg mt-6">
            block, disable, or otherwise affect any advertising, banner window, tab, link to websites and services, or
            other features that are part of the Software;
          </p>

          <p class="tracking-wide font-normal text-lg mt-6">provide false information when registering the Software;</p>

          <p class="tracking-wide font-normal text-lg mt-6">
            digitally transmit or make available the Software or its content through local networks, intranets,
            extranets, FTP, online discussion boards, forums, list-serve, peer-to-peer networks or technologies,
            newsgroups, bulletin boards, or any other mode of shared communication system, or place the Software onto a
            server so that it is accessible via a pubic network;
          </p>

          <p class="tracking-wide font-normal text-lg mt-6">
            use the Software in any way that violates this ULA or any law; or
          </p>

          <p class="tracking-wide font-normal text-lg mt-6">
            authorize or assist any third party to do any of the things described in this section.
          </p>

          <p class="tracking-wide font-normal text-lg mt-6"><strong>Privacy</strong></p>

          <p class="tracking-wide font-normal text-lg mt-6">
            By using the Salve cloud-based software, you allow Salve to collect information relating to your use of the
            Software, such as the frequency of your use of the Software and of certain features, and information on
            errors occurring during your use of the Software. This usage data will be used to diagnose performance
            issues and improve the reliability of the Software and its features. This data will not be tied to any
            information that would personally identify you.
          </p>

          <p class="tracking-wide font-normal text-lg mt-6">
            You hereby grant Salve the unrestricted right to retain and use such data in the normal course of Salve
            business for any lawful purpose.
          </p>

          <p class="tracking-wide font-normal text-lg mt-6"><strong>Limitation of Liability</strong></p>

          <p class="tracking-wide font-normal text-lg mt-6">
            EXCEPT AS REQUIRED BY LAW, SALVE AND ITS EMPLOYEES, DIRECTORS, LICENSORS, CONTRIBUTORS AND AGENTS WILL NOT
            BE LIABLE FOR ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES ARISING OUT OF
            OR IN ANY WAY RELATING TO THIS ULA OR THE USE OF OR INABILITY TO USE THE SOFTWARE, INCLUDING WITHOUT
            LIMITATION DAMAGES FOR LOSS OF GOODWILL, WORK STOPPAGE, LOST PROFITS, LOSS OF DATA, AND COMPUTER FAILURE OR
            MALFUNCTION, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES AND REGARDLESS OF THE THEORY (CONTRACT,
            NEGLIGENCE, STRICT LIABILITY OR OTHERWISE) UPON WHICH SUCH CLAIM IS BASED.
          </p>

          <p class="tracking-wide font-normal text-lg mt-6"><strong>Disclaimer of Warranty</strong></p>

          <p class="tracking-wide font-normal text-lg mt-6">
            YOU ACCEPT THE SOFTWARE “AS IS” AND WITH ALL FAULTS (IF ANY). SALVE DISCLAIMS ALL WARRANTIES, EXPRESS OR
            IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE.
            SALVE MAKES NO WARRANTY OR REPRESENTATIONS WHATSOEVER REGARDING THE CONTENT OF THE CLOUD-BASED SOFTWARE AND
            YOUR USE OF THE CLOUD-BASED SOFTWARE, OR THE SUITABILITY OF THE SOFTWARE TO MEET YOUR SPECIFIC NEEDS.
          </p>

          <p class="tracking-wide font-normal text-lg mt-6"><strong>Violations of this ULA</strong></p>

          <p class="tracking-wide font-normal text-lg mt-6">
            Salve reserves all rights not specifically granted to you above. Salve will have the right to proceed
            against you in the event that you infringe Salve’s rights. Any use not within the precise scope of the
            license set forth herein will be considered an infringement. You acknowledge and agree that Salve’s damages
            in the event of your violation of this ULA will be substantial and that Salve will suffer irreparable harm
            in such event. As such, Salve shall have the right to obtain equitable remedies, including but not limited
            to recovery of damages, obtaining injunctions, recovering statutory damages, recovering attorney fees, and
            any other available legal remedy.
          </p>

          <p class="tracking-wide font-normal text-lg mt-6"><strong>Termination</strong></p>

          <p class="tracking-wide font-normal text-lg mt-6">
            Salve shall have the sole and exclusive right to immediately terminate this ULA and suspend your license to
            use the Software should you fail to perform any obligation required under this ULA, engage in activity that
            Salve deems harmful to its well-being or if you become bankrupt or insolvent. This ULA takes effect upon
            your installation of the Software and remains effective until terminated. Upon termination of this ULA by
            Salve.
          </p>

          <p class="tracking-wide font-normal text-lg mt-6"><strong>Waiver &amp; Severability</strong></p>

          <p class="tracking-wide font-normal text-lg mt-6">
            Salve’s waiver of any breach of this ULA shall not constitute waiver of subsequent breaches. If any part of
            this ULA is found void and unenforceable, it will not affect the validity of the balance of this ULA, which
            will remain valid and enforceable.
          </p>

          <p class="tracking-wide font-normal text-lg mt-6"><strong>Electronic Notices</strong></p>

          <p class="tracking-wide font-normal text-lg mt-6">
            You consent that Salve may provide you with information and notices regarding the cloud-based Software and
            Salve via the email address you designate. Salve may provide notices to you via (i) email if you have
            provided Salve with a valid email address, or (ii) by posting the notice on the Salve website or any other
            platform or site Salve owns and operates. You may withdraw your consent for electronic notices.
          </p>

          <p class="tracking-wide font-normal text-lg mt-6"><strong>Governing Law</strong></p>

          <p class="tracking-wide font-normal text-lg mt-6">
            This ULA shall be governed by and construed under the laws of the State of Delaware. You consent and agree
            that all legal proceedings relating to the subject matter of this ULA shall be maintained in courts sitting
            within the State of Delaware, and that jurisdiction and venue for such proceedings shall lie exclusively
            with such courts.
          </p>

          <p class="tracking-wide font-normal text-lg mt-6">
            This agreement is enforceable against You. If You do not agree to the terms of this agreement, please do not
            use this software.
          </p>

          <p class="tracking-wide font-normal text-lg mt-6">
            By using the software, You are accepting the terms of this ULA. You are also acknowledging that You have
            read, understand and agree to the Salve Terms of Service found at:
            <a
              target="_blank"
              rel="noopener noreferrer nofollow"
              :href="route('terms')"
              >https://app.getsalve.co/terms-and-conditions</a
            >
          </p>

          <p class="tracking-wide font-normal text-lg mt-6"><strong>Questions or Comments</strong></p>

          <p class="tracking-wide font-normal text-lg mt-6">
            Salve welcomes your questions or comments. Any user of Salve’s Cloud-Based Software may reach Salve at
            <a
              target="_blank"
              rel="noopener noreferrer nofollow"
              href="mailto:hello@getsalve.co"
              >hello@getsalve.co</a
            >
            or call (321) 364-3271.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'

export default {
  components: {
    Head,
    Link
  }
}
</script>
